import { AnalyticsWindow } from "./analytics-window"
import { DestinationPlugin } from "@amplitude/analytics-types"
import { EnrichmentPlugin } from "@amplitude/analytics-types"
import get6senseData from "./analytics-6sense"
import getConsentsData from "./analytics-consents"
import getOptimizelyData, {
  sendEventToOptimizely,
} from "./analytics-optimizely"

declare let window: AnalyticsWindow

export function GTMPlugin(): DestinationPlugin {
  return {
    name: "google-tag-manager",
    type: "destination" as const,
    setup: async () => undefined,
    execute: async event => {
      if (event.event_type === "Marketing Form Submitted") {
        const data = {
          event: event.event_type,
          page_url: window.location.href,
          page_path: window.location.pathname,
        }
        window.dataLayer.push(data)
      }

      return {
        code: 200,
        event: event,
        message: "Event pushed onto GTM Data Layer",
      }
    },
  }
}

export function eventTrackingEnrichment(pageTheme: string): EnrichmentPlugin {
  return {
    name: "event-tracking-enrichment",
    type: "enrichment",
    setup: async () => undefined,
    execute: async event => {
      const url = window.location.href
      const path = window.location.pathname
      const pageTitle = document.title

      event.event_properties = {
        ...event.event_properties,
        "Page url": url,
        "Page path": path,
        "Page title": pageTitle,
        "Page theme": pageTheme,
        Context: "Marketing website",
      }
      if (event.event_type !== "[Amplitude] Page Viewed") {
        return event
      }

      event.event_type = "Marketing Page Viewed"

      event.user_properties = {
        ...event.user_properties,
        $set: {
          ...getConsentsData(),
          ...getOptimizelyData(),
          ...get6senseData(),
        },
      }

      event.event_properties = {
        ...event.event_properties,
        "Browser language": navigator.language,
        ...getOptimizelyData(),
        ...getConsentsData(),
      }

      sendEventToOptimizely("marketing_page_viewed")

      return event
    },
  }
}
